export default function searchDropCloseMobile() {
  $(document).mouseup(function (e) {
    var container = $(".search-holder");
    if (container.has(e.target).length === 0) {
      container.removeClass('active');
    }

    $('.btn-search-back').on('click', function () {
      var container = $(".search-holder");
      container.removeClass('active');
      $('#back-top').addClass('is-visible');
    });
  });
}